"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ImagingStudy_Series = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_unsignedInt_1 = require("../Scalar/RTTI_unsignedInt");
var RTTI_Coding_1 = require("./RTTI_Coding");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_ImagingStudy_Performer_1 = require("./RTTI_ImagingStudy_Performer");
var RTTI_ImagingStudy_Instance_1 = require("./RTTI_ImagingStudy_Instance");
exports.RTTI_ImagingStudy_Series = t.recursion('IImagingStudy_Series', function () {
    return t.intersection([
        t.type({
            modality: RTTI_Coding_1.RTTI_Coding
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            uid: RTTI_id_1.RTTI_id,
            _uid: RTTI_Element_1.RTTI_Element,
            number: RTTI_unsignedInt_1.RTTI_unsignedInt,
            _number: RTTI_Element_1.RTTI_Element,
            description: t.string,
            _description: RTTI_Element_1.RTTI_Element,
            numberOfInstances: RTTI_unsignedInt_1.RTTI_unsignedInt,
            _numberOfInstances: RTTI_Element_1.RTTI_Element,
            endpoint: t.array(RTTI_Reference_1.RTTI_Reference),
            bodySite: RTTI_Coding_1.RTTI_Coding,
            laterality: RTTI_Coding_1.RTTI_Coding,
            specimen: t.array(RTTI_Reference_1.RTTI_Reference),
            started: RTTI_dateTime_1.RTTI_dateTime,
            _started: RTTI_Element_1.RTTI_Element,
            performer: t.array(RTTI_ImagingStudy_Performer_1.RTTI_ImagingStudy_Performer),
            instance: t.array(RTTI_ImagingStudy_Instance_1.RTTI_ImagingStudy_Instance)
        })
    ]);
});
//# sourceMappingURL=RTTI_ImagingStudy_Series.js.map